/* Globes
 * A set of globe functions that complete on a generic globe defined in globe.js
 */

export default function globeProjections () {
  return {
    Orthographic: {
      initGlobe: function() {
        this.allPointVisible = false; //all globe isn't visible
          //projection function
        this.projection = d3.geoOrthographic()
                                .scale(this.scale)
                                .translate([this.width / 2, this.height / 2])
                                .precision(0.1)
                                .clipAngle(90);
        this.earthSurfaceScaleRatio = earthcorevisu.R_EARTH/earthcorevisu.R_OUTER_CORE;
        this.earthSurfaceProjection = d3.geoOrthographic()
                                .scale(this.scale*this.earthSurfaceScaleRatio)
                                .translate([this.width / 2, this.height / 2])
                                .precision(0.1)
                                .clipAngle(90);
        this.floatingContinents = true;
      },

      isPointVisible: function(pointSphCoord,viewAxis,verb=false) {
        if (verb) {
          console.log(pointSphCoord, viewAxis);
        }
        return (Math.sin(pointSphCoord[0]*Math.PI/180) * Math.sin(-viewAxis[0]*Math.PI/180) *
                Math.cos(pointSphCoord[1]*Math.PI/180 + viewAxis[1]*Math.PI/180) +
                Math.cos(pointSphCoord[0]*Math.PI/180) * Math.cos(-viewAxis[0]*Math.PI/180) < 0);
      },

      getInitScale: function() {
        return 0.95 / 1.835 * Math.min(this.width,this.height) / 2;
      },

      setScale: function(scale,draw=true) {
        if (scale > 0.8 * Math.min(this.width,this.height) / 2) {
          this.floatingContinents = false;
        } else {
          this.floatingContinents = true;
        }
      }
    },

    Aitoff: {
      initGlobe : function(size,name) {
          //specific behavior
        this.roty = null; //no y rotation, keep x rotation
        this.cantranslate = true;
        this.translY = true;

          //projection function
        this.projection = d3.geoAitoff()
                                .scale(this.scale)
                                .translate([this.width / 2, this.height / 2])
                                .precision(0.1);
        this.earthSurfaceScaleRatio = 1;
        this.earthSurfaceProjection = d3.geoAitoff()
                                .scale(this.scale*this.earthSurfaceScaleRatio)
                                .translate([this.width / 2, this.height / 2])
                                .precision(0.1);
      },

      getInitScale : function() {
        return 0.95 * Math.min(this.width/ 2 , this.height) / Math.PI; //customscale
      },

      isDiscountinuous: function(position,newposition) {
        var φdiscountinuity = (-this.projection.rotate()[0]+180+360)%360;
        var φ = position[1];
        var φnew = newposition[1];
        if ((φnew - φ) > 180 || (φ - φnew) > 180) { //particle goes trough φ=0
          if ((φdiscountinuity > φ) && (φdiscountinuity < φnew)) {
            return false;
          } else if ((φdiscountinuity > φnew) && (φdiscountinuity < φ)) {
            return false;
          } else {
            return true;
          }
        }
        if ((φ <= φdiscountinuity) && (φnew > φdiscountinuity)) {
          return true;
        }
        if ((φ >= φdiscountinuity) && (φnew < φdiscountinuity)) {
          return true;
        }
        return false;
      }

    },

    "Orthographic North Pole": {
      initGlobe: function() {
        this.allPointVisible = false; //all globe isn't visible
        this.canrotate = false; //no rotation
        this.cantranslate = true; // translation
        this.translX = true;
        this.translY = true;
          //projection function
        this.projection = d3.geoOrthographic()
                                .scale(this.scale)
                                .translate([this.width / 2, this.height / 2])
                                .rotate([0, -90])
                                .precision(0.1)
                                .clipAngle(90);
        this.earthSurfaceScaleRatio = 1;
        this.earthSurfaceProjection = d3.geoOrthographic()
                                .scale(this.scale*this.earthSurfaceScaleRatio)
                                .translate([this.width / 2, this.height / 2])
                                .rotate([0, -90])
                                .precision(0.1)
                                .clipAngle(90);
        this.floatingContinents = false;
      },

      isPointVisible: function(pointSphCoord,viewAxis,verb=false) {
        if (verb) {
          console.log(pointSphCoord, viewAxis);
        }
        return (Math.sin(pointSphCoord[0]*Math.PI/180) * Math.sin(-viewAxis[0]*Math.PI/180) *
                Math.cos(pointSphCoord[1]*Math.PI/180 + viewAxis[1]*Math.PI/180) +
                Math.cos(pointSphCoord[0]*Math.PI/180) * Math.cos(-viewAxis[0]*Math.PI/180) < 0);
      },

      getInitScale: function() {
        return 0.95 * Math.min(this.width,this.height) / 2;
      },

      setScale: function(scale,draw=true) {
        if (scale > 0.8 * Math.min(this.width,this.height) / 2) {
          this.floatingContinents = false;
        } else {
          this.floatingContinents = true;
        }
      }
    },

    "Orthographic South Pole": {
      initGlobe: function() {
        this.allPointVisible = false; //all globe isn't visible
        this.canrotate = false; //no rotation
        this.cantranslate = true; // translation
        this.translX = true;
        this.translY = true;
          //projection function
        this.projection = d3.geoOrthographic()
                                .scale(this.scale)
                                .translate([this.width / 2, this.height / 2])
                                .rotate([0, 90])
                                .precision(0.1)
                                .clipAngle(90);
        this.earthSurfaceScaleRatio = 1;
        this.earthSurfaceProjection = d3.geoOrthographic()
                                .scale(this.scale*this.earthSurfaceScaleRatio)
                                .translate([this.width / 2, this.height / 2])
                                .rotate([0, 90])
                                .precision(0.1)
                                .clipAngle(90);
        this.floatingContinents = false;
      },

      isPointVisible: function(pointSphCoord,viewAxis,verb=false) {
        if (verb) {
          console.log(pointSphCoord, viewAxis);
        }
        return (Math.sin(pointSphCoord[0]*Math.PI/180) * Math.sin(-viewAxis[0]*Math.PI/180) *
                Math.cos(pointSphCoord[1]*Math.PI/180 + viewAxis[1]*Math.PI/180) +
                Math.cos(pointSphCoord[0]*Math.PI/180) * Math.cos(-viewAxis[0]*Math.PI/180) < 0);
      },

      getInitScale: function() {
        return 0.95 * Math.min(this.width,this.height) / 2;
      },

      setScale: function(scale,draw=true) {
        if (scale > 0.8 * Math.min(this.width,this.height) / 2) {
          this.floatingContinents = false;
        } else {
          this.floatingContinents = true;
        }
      }
    },

    /*"Cylindrical Equal Area" :{
      initGlobe : function(size,name) {
          //specific behavior
        this.roty = null; //no y rotation, keep x rotation
        this.cantranslate = true;
        this.translY = true;
          //projection function
        this.projection = d3.geoCylindricalEqualArea()
                                .scale(this.scale)
                                .translate([this.width / 2, this.height / 2])
                                .precision(0.1);
      },

      getInitScale : function() {
        return 0.95 * Math.min(this.width/ 2 , this.height) / Math.PI; //customscale
      },

      isDiscountinuous: function(position,newposition) {
        var φdiscountinuity = (-this.projection.rotate()[0]+180+360)%360;
        var φ = position[1];
        var φnew = newposition[1];
        if ((φnew - φ) > 180 || (φ - φnew) > 180) { //particle goes trough φ=0
          if ((φdiscountinuity > φ) && (φdiscountinuity < φnew)) {
            return false;
          } else if ((φdiscountinuity > φnew) && (φdiscountinuity < φ)) {
            return false;
          } else {
            return true;
          }
        }
        if ((φ <= φdiscountinuity) && (φnew > φdiscountinuity)) {
          return true;
        }
        if ((φ >= φdiscountinuity) && (φnew < φdiscountinuity)) {
          return true;
        }
        return false;
      }

    },*/

    /*"Azimuthal equal area (North)" : {
      initGlobe : function(size,name) {
        //specific behavior
        this.canrotate = false; //no rotation
        this.cantranslate = true; // translation
        this.translX = true;
        this.translY = true;

        this.scale = this.scale / 2; //customscale
        this.projection = d3.geoAzimuthalEqualArea()
                              .scale(this.scale)
                              .translate([this.width / 2, this.height / 2])
                              .rotate([0, -90])
                              .clipAngle(180 - 0.01)
                              .precision(0.1);
      },

      getInitScale : function() {
        return 0.95 * Math.min(this.width , this.height) / 2; //customscale
      },

      isDiscountinuous : function(position,newposition) {
        if (position[0]>179 || newposition[0]>179) {
          return true;
        }
        return false;
      }
    },*/

    /*"Azimuthal equal area (South)" : {
      initGlobe : function(size,name) {
        //specific behavior
        this.canrotate = false; //no rotation
        this.cantranslate = true; // translation
        this.translX = true;
        this.translY = true;

        this.scale = this.scale / 2; //customscale
        this.projection = d3.geoAzimuthalEqualArea()
                              .scale(this.scale)
                              .translate([this.width / 2, this.height / 2])
                              .rotate([0, 90])
                              .clipAngle(180 - 0.01)
                              .precision(0.1);
      },

      getInitScale : function() {
        return this.scale = 0.95 * Math.min(this.width , this.height) / 2; //customscale
      },

      isDiscountinuous : function(position,newposition) {
        if (position[0]<2 || newposition[0]<2) {
          return true;
        }
        return false;
      }
    },*/

    Stereographic: {
      initGlobe : function(size, name) {
        //specific behavior
        this.canrotate = true; //no rotation
        this.cantranslate = true; // translation
        this.canzoom = true;


        //this.scale = this.scale / 2; //customscale
        this.projection = d3.geoStereographic()
                              .scale(this.scale)
                              .translate([this.width / 2, this.height / 2])
                              // .rotate([0, 90])
                              .clipAngle(90);
                              // .precision(0.1);
        this.earthSurfaceProjection = d3.geoStereographic()
                              .scale(this.scale)
                              .translate([this.width / 2, this.height / 2])
                              // .rotate([0, 90])
                              .clipAngle(90);
      },

    //   getInitScale : function() {
    //     return this.scale = 0.95 * Math.min(this.width , this.height) / 2; //customscale
    //   },
    //
    //   isDiscountinuous : function(position,newposition) {
    //     return (position[0]<2 || newposition[0]<2)
    }
  };
}



//////////////////
// WEBPACK FOOTER
// ./src/model/globes.js
// module id = 4
// module chunks = 0